import React, { FC } from 'react';
import styles from './DataLabelPairing.module.scss';

export interface DataLabelPairingProps {
    data: any;
    label: string;
    testId?: string;
}

const DataLabelPairing: FC<DataLabelPairingProps> = ({
    data,
    label,
    testId,
}) => (
    <div
        className={styles.DataLabelPairing}
        data-testid={testId ?? 'DataLabelPairing'}
    >
        <div className={styles.label}>{label}:</div>
        <div className={styles.data}>{data}</div>
    </div>
);

export default DataLabelPairing;
